export const SETSERVERERROR = 'SETSERVERERROR';
